import product0 from "./product/product0.png";
import product1 from "./product/product1.png";
import product2 from "./product/product2.png";
import product3 from "./product/product3.png";
import product4 from "./product/product4.png";
import product5 from "./product/product5.png";
import product6 from "./product/product6.png";
import product7 from "./product/product7.png";
import product8 from "./product/product8.png";
import product9 from "./product/product9.png";
import product10 from "./product/product10.png";
export default [
  {
    name: "位置大数据",
    introduction: "基于通信网络大数据，为政府治理、行业应用、民生安全提供大数据洞察及相关位置服务。",
    title: "位置大数据",
    document: [
      {
        type: "text",
        value:
          "作为数字经济的重要组成部分，位置信息在与其他领域和技术的融合拥有巨大潜力与空间。我公司位置大数据平台基于通信网络大数据，采用循环神经网络等机器学习算法、指纹定位、路网拟合定位、室内立体分层定位等高精度定位技术，大幅度提升位置大数据定位精度、处理效率和应用范围，由原先的500米精度提升到平均50米内。"
      },
      {
        type: "img",
        value: require("./product/位置大数据_0.png")
      },
      {
        type: "text",
        value:
          "目前，位置大数据平台已覆盖中国移动、中国联通13亿+用户，实现全时全网用户及物联终端位置定位，经脱敏后，安全可靠的为政府治理、行业应用、民生安全提供大数据洞察及相关位置服务，满足各行业高精度位置服务应用需求。"
      },
      {
        type: "img",
        value: require("./product/位置大数据_1.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 0,
        value: "智慧交通"
      },
      {
        type: "text",
        value:
          "融合位置信令数据和传统交通监测数据，构建智慧交通大数据平台，提供实时路况监控，交通拥堵诱导，人口迁徙分析、用户出行分析、城市交通规划及优化分析，全面提升交通系统运行效率和管理水平。"
      },
      {
        type: "img",
        value: require("./product/智慧交通_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 1,
        value: "智慧文旅"
      },
      {
        type: "text",
        value:
          "面向旅游管理部门和涉旅企业，提供热门旅游路线、景区实时客流、景区游客来源住宿、游客属性分类等多维度客情分析，实现旅游行业精准管理、旅游宏观数据分析及预测。"
      },
      {
        type: "img",
        value: require("./product/智慧文旅_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 2,
        value: "公共服务"
      },
      {
        type: "text",
        value:
          "基于用户位置特征向政府、公安等行政主管部门提供就业分析、精准扶贫、治安监控、特殊人群关爱、110报警定位服务，提升政府治理水平，保障民众生命财产安全。"
      },
      {
        type: "img",
        value: require("./product/公共服务_0.png")
      },
      {
        type: "subheading",
        level: 0,
        index: 3,
        value: "应急救灾"
      },
      {
        type: "text",
        value:
          "对水灾、地震、泥石流、坍塌、煤矿防盗采、煤矿事故等灾害地区人口情况进行持续位置统计分析，支撑事前预警、事中诊断、事后评估等应急救灾服务。"
      },
      {
        type: "img",
        value: require("./product/应急救灾_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 4,
        value: "金融征信"
      },
      {
        type: "text",
        value:
          "为金融行业提供信用评估、位置信息核验等服务，识别潜在信贷风险，提高信贷审核效率、降低违约率，保障金融业务安全。"
      },
      {
        type: "img",
        value: require("./product/金融征信_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 5,
        value: "数字零售"
      },
      {
        type: "text",
        value:
          "对商业区域客流、交通、人口特征及其分布、消费偏好等情况进行综合分析，为商业客户经营、选址、广告投放提供全面价值评估。"
      },
      {
        type: "img",
        value: require("./product/数字零售_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 6,
        value: "商务会展"
      },
      {
        type: "text",
        value:
          "全景化呈现大型展会、重要场景、重要集会客流聚集和客流特征数据，为现场安保提供实时客流统计、分场景监控、客流预警、客流疏导等服务，防止人员过度聚集等潜在安全问题。"
      },
      {
        type: "img",
        value: require("./product/商务会展_0.png")
      },
      {
        type: "subheading",
        level: 0,
        index: 7,
        value: "分析报告"
      },
      {
        type: "text",
        value:
          "为政府机构、合作企业提供客观量化、动态更新的脱敏的大数据分析报告，洞察市场变化趋势，了解不同区域、不同客群产品体验及用户需求，为企业制定运营策略及目标提供决策依据。"
      },
      {
        type: "img",
        value: require("./product/分析报告_0.jpg")
      }
    ],
    id: "location-service",
    img: product8
  },
  {
    name: "网络自智",
    introduction: "以自动化和智能化为核心打造数智化能力，实现网络智能评估、智能优化、智能规划、智能运维。",
    title: "网络自智",
    document: [
      {
        type: "text",
        value:
          "名通公司自智网络以自动化和智能化为核心，通过建立网络感知、认知、决策、执行、评估主引擎驾驶舱，打造“自服务、自愈合、自优化”的数智化能力，实现网络智能评估、智能优化、智能规划、智能运维，推动网络运维自身的数智化转型升级。"
      },
      {
        type: "img",
        value: require("./product/网络自智_0.png")
      },
      {
        type: "subheading",
        level: 0,
        index: 0,
        value: "智能评估"
      },
      {
        type: "text",
        value:
          "应用大数据处理技术进行道路、场景、物业小区、楼宇、栅格维度的覆盖、干扰、速率、时延等网络质量和业务感知评估，从全局到微观掌握网络竞争优劣势区域，引导网络资源精准投放。"
      },
      {
        type: "img",
        value: require("./product/智能评估_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 1,
        value: "智能优化"
      },
      {
        type: "text",
        value:
          "结合告警、资源、覆盖、干扰、容量、互操作参数等多维数据，采用AI人工智能等技术手段进行问题根因分析，为网络优化提供智能解决方案。"
      },
      {
        type: "img",
        value: require("./product/智能优化_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 2,
        value: "智能规划"
      },
      {
        type: "text",
        value:
          "以AI聚类和规建维优定性算法挖掘需规划解决的网络覆盖及容量问题区域，通过区域内常驻用户、竞对覆盖、市场价值、投诉等多维数据综合评估区域建站价值和建设优先级，并实现区域规划站点选型、选址以及选址效果仿真评估。"
      },
      {
        type: "img",
        value: require("./product/智能规划_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 3,
        value: "智能运维"
      },
      {
        type: "text",
        value:
          "基于微服务架构设计，通过沉淀运维原子能力、通用业务能力、公共基础能力和应用集成能力，构建用户统一、流程完备、数据融通的智能运维管理中心，实现运维工作的线上化、标准化、自动化、智能化。"
      },
      {
        type: "img",
        value: require("./product/智能运维_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 4,
        value: "感知及满意度提升"
      },
      {
        type: "text",
        value:
          "结合用户投诉数据和用户满意度调查数据，采用机器学习算法建立用户语音感知、上网感知评估模型，分析影响用户网络感知的主要敏感因素，定位网络质量差的短板区域及感知较差的用户，牵引以客户感知为目标的网络优化工作，提升用户满意度。"
      },
      {
        type: "img",
        value: require("./product/感知_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 5,
        value: "节能减排盘活资源"
      },
      {
        type: "text",
        value:
          "基于大数据技术开展网络共覆盖分析，业务趋势预测分析，根据业务潮汐状况实时均衡调度载波资源，根据业务忙闲状况实施一站一策动态节电策略，在不影响客户感知的前提下实现资源盘活、节能减排、降本增效。"
      },
      {
        type: "img",
        value: require("./product/节能减排_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 6,
        value: "应急保障"
      },
      {
        type: "text",
        value:
          "以区域内重点场馆、重要用户群、重点业务为保障对象，实时监控网络指标、快速洞察用户分布及网络问题，实现网络资源动态调整，确保保障期间重要地点通信网络的安全畅通。"
      },
      {
        type: "img",
        value: require("./product/应急保障_0.jpg")
      }
    ],
    id: "autonomous-networks",
    img: product1
  },
  {
    name: "掌端APP",
    introduction: "打破时空束缚，聚焦工作末梢，面向管理人员与一线人员提供一体化网络运营运维支撑。",
    title: "掌端APP",
    document: [
      {
        type: "text",
        value:
          "掌端APP将网络数字化运营工作从PC延伸至移动端，打破时空束缚，聚焦工作末梢，面向管理人员与一线人员提供一体化网络运营运维支撑。"
      },
      {
        type: "img",
        value: require("./product/掌端APP_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 0,
        value: "掌上能力中心"
      },
      {
        type: "text",
        value:
          "将掌端通用能力组件化，根据业务场景选择、编排、聚合能力组件，快速形成面向多专业、“千人千面”的移动应用，实现线上延伸，为一线赋能，快速响应网络运维和业务支撑需求。"
      },
      {
        type: "img",
        value: require("./product/掌上能力_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 1,
        value: "掌上门户"
      },
      {
        type: "text",
        value:
          "以统一运营、数据集中、信息聚合为核心，打破各应用APP之间的壁垒，提供三方应用接入和管理能力，统一安全管理能力，统一待办推送能力，面向用户提供可视化、显性化的管理界面，实现运维管理数据统一监控，统一分析。"
      },
      {
        type: "img",
        value: require("./product/掌上门户_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 2,
        value: "掌上运维"
      },
      {
        type: "text",
        value:
          "以精细管理、精准调度、精确支撑、精益运营为核心构建掌上运维体系，为家宽装维、集客装维、代维管理、故障处理提供业务支撑和运维监控，并辅以ChatOps运维机器人，实现IT赋能和AI注智。"
      },
      {
        type: "img",
        value: require("./product/掌上运维_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 3,
        value: "掌上智优"
      },
      {
        type: "text",
        value:
          "打通移动端与平台端的数据链接，提供基于网格、场景、楼宇、栅格等维度的网络质量分析，监测网络关键性能指标，为一线规建维优人员提供移动工作台和自动优化工具，辅助现场方案执行与信息反馈。"
      },
      {
        type: "img",
        value: require("./product/掌上智优_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 4,
        value: "感知测试"
      },
      {
        type: "text",
        value:
          "基于普通商用终端开展覆盖测试、无线测试、语音测试、上网测试、视频测试，支撑网络规划、网络优化和用户投诉处理，同时建立基于真实感知的网络质量指标评估体系，持续提升网络业务质量和用户感知质量。"
      },
      {
        type: "img",
        value: require("./product/感知测试_0.jpg")
      }
    ],
    id: "optimizeonhand",
    img: product4
  },
  {
    name: "通用技术",
    introduction: "拥抱变化、持续创新，在产品设计研发中研究吸收最前沿技术，打造通用技术能力，提升IT开发效率。",
    title: "通用技术",
    document: [
      {
        type: "text",
        value:
          "名通公司以拥抱变化、持续创新为宗旨，在产品设计研发中研究吸收最新、最前沿技术，打造通用技术能力，提升IT开发效率。"
      },
      {
        type: "subheading",
        level: 0,
        index: 0,
        value: "DEVOPS平台"
      },
      {
        type: "text",
        value:
          "打通开发、测试、运维之间的壁垒，实现了代码-自动化构建-自动化部署(测试环境)-自动化测试-自动化部署(生产环境)的全流程的自动化，形成了相互协作、拥抱需求、更频繁的发布、及时反馈以及快速改进的工作氛围。"
      },
      {
        type: "img",
        value: require("./product/DEVOPS_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 1,
        value: "能力开放平台"
      },
      {
        type: "text",
        value:
          "广泛采用开源技术框架和技术组件，以中台化、微服务技术架构搭建能力开发平台，支持云化、容器化部署并集成敏捷开发流水线，实现能力快速调用、能力运营和管控。"
      },
      {
        type: "img",
        value: require("./product/能力开放_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 2,
        value: "GIS引擎"
      },
      {
        type: "text",
        value:
          "针对不同应用场景，提供组件化的GIS能力开放服务；支持关联工单、业务数据进行在线GIS调试、渲染；支持WEB、APP、H5；支持2D/3D多个模型在线开发、调试、渲染，提供多类图层呈现。"
      },
      {
        type: "img",
        value: require("./product/GIS_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 3,
        value: "流程引擎"
      },
      {
        type: "text",
        value:
          "通过拖、拉、拽等方式即可来完成流程/工单设计、配置 ；支持在线Web流程设计、在线Web表单设计。"
      },
      {
        type: "img",
        value: require("./product/流程引擎_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 4,
        value: "Easy报表"
      },
      {
        type: "text",
        value:
          "通过拖、拽等简易操作定制各类报表；支持自定义数据源和样式；丰富的报表元素选择；报表排版、图表联动、地图添加、报表分享。"
      },
      {
        type: "img",
        value: require("./product/Easy报表_0.jpg")
      },
      {
        type: "subheading",
        level: 0,
        index: 5,
        value: "AI能力"
      },
      {
        type: "text",
        value:
          "破解传统技术路径面临的难题，应用文字识别、图像处理、数据挖掘、自然语言和知识图谱等AI技术进行图文识别、工单质检，故障诊断，通过数智化方式大幅提升工作效率。"
      },
      {
        type: "img",
        value: require("./product/AI能力_0.jpg")
      },
      {
        type: "text",
        value:
          "名通公司在软件开发和运维领域已深耕17年，具备深厚的技术底蕴、广泛的市场覆盖和丰富的实战经验，未来将继续与客户在关键技术攻关、应用场景创新等方面深入合作，为各行业数智化转型贡献力量。"
      }
    ],
    id: "general-technology",
    img: product0
  }
];



// WEBPACK FOOTER //
// ./src/assets/productInfos.js